import { render } from "./Navbar.vue?vue&type=template&id=13ef6072&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=13ef6072&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ef6072"]])

export default __exports__